
import { app, db } from '~/firebaseInstance'
import { collection, getDocs, addDoc, doc, setDoc, getDoc } from 'firebase/firestore'
import { createGlobalState } from "@vueuse/core";

export const useFirestore = createGlobalState(() => {

  const storeId = ref("")
  const setStoreId = (_storeId: string) => {
    storeId.value = _storeId
  }



  const getRootDataRef = () => {
    return doc(db, 'customers', storeId.value)
  }

  const getFeatureBlockRef = () => {
    return doc(db, 'appState', 'feature_block')
  }

  // --- per-channel appState docs -------------------------------------------
  // Doc ids are build-time, one set per release channel (production / beta /
  // preview / development) — see releaseChannel.mjs. Testing a force reload or
  // an outage banner on beta must never touch production clients.

  const getForceReloadRef = () => {
    return doc(db, 'appState', useReleaseChannel().forceReloadDoc)
  }

  // Global service announcement shown as a banner above the navbar
  // (ServiceAnnouncementBanner.vue) — e.g. "Google/Firebase outage".
  const getAnnouncementRef = () => {
    return doc(db, 'appState', useReleaseChannel().announcementDoc)
  }

  // Markdown card on the home page (HomeAnnouncementCard.vue).
  const getHomeMessageRef = () => {
    return doc(db, 'appState', useReleaseChannel().homeMessageDoc)
  }

  const getFeatureFlagsRef = () => {
    return doc(db, 'appState', 'feature_flags')
  }

  const getReceiptsCollectionRef = () => {
    return collection(db, 'customers', storeId.value, '__receipts')
  }

 

  const getSummaryCollectionRef = () => {
    return collection(db, 'customers', storeId.value, 'summary')
  }

  // Receipt running-number counter: one doc per YYYYMM month bucket, plus one
  // tiny idempotency-marker doc per queued increment nonce (see
  // pos.receiptIdCounter.ts flushCounterIncrements).
  const getReceiptCounterDocRef = (month: string) => {
    return doc(db, 'customers', storeId.value, 'receipt-counters', month)
  }

  const getReceiptCounterNonceDocRef = (month: string, nonce: string) => {
    return doc(db, 'customers', storeId.value, 'receipt-counters', month, 'nonces', nonce)
  }

  // --- mobile-v2 -----------------------------------------------------------
  // The Android client reads its table layout and occupancy from these two docs
  // instead of the legacy RTDB `tables/customercounts` int-array. Written by the
  // main cashier only (see cloud.mobile-v2.plugin.ts).
  //
  // Order INTAKE is not here — it stays on RTDB, using the same handshake shape
  // as the terminal silo (see pos.mobile-v2.ts / useRealtimeDatabase).

  const getMobileLayoutRef = () => {
    return doc(db, 'customers', storeId.value, 'data', 'mobile')
  }

  const getTablesSummaryRef = () => {
    return doc(db, 'customers', storeId.value, 'data', 'tables_summary')
  }

  const browserRef = (browserId: string) => {
    return doc(db, 'browserId', browserId)
  }

  const getMigratedDocRef = () => {
    return doc(db, 'migrated', storeId.value)
  }

  // Beta channel: a doc here means the shop is routed to the beta build.
  // Takes storeId explicitly — the beta plugin runs off authStore.storeId
  // before bootstrap calls setStoreId() below.
  const getBetaWhiteListRef = (id: string) => {
    return doc(db, 'beta_whitelist', id)
  }





  return {

    setStoreId,
    // exposed read-only so callers can check "is the store id resolved yet?" —
    // getRootDataRef() throws on an empty id rather than returning null.
    storeId,
    browserRef,
    getRootDataRef,
    getDoc,
    getReceiptsCollectionRef,
    getSummaryCollectionRef,
    getReceiptCounterDocRef,
    getReceiptCounterNonceDocRef,
    getFeatureBlockRef,
    getForceReloadRef,
    getAnnouncementRef,
    getHomeMessageRef,
    getFeatureFlagsRef,
    getMigratedDocRef,
    getBetaWhiteListRef,
    getMobileLayoutRef,
    getTablesSummaryRef,
  }
})
